import { useEffect, useState, useRef } from 'react';
import "./Contact.css";
import Footer from './Footer';


const Contact = ({ lang }) => {
    let sizes, canvas, scene, camera, light, renderer, box;

    // 오버스크롤, 리사이즈 이벤트 등록 (Three.js 코드와 무관)
    useEffect(() => {
        // console.log("Contact use effect");
        let startY = 0;
        let moveY = 0;

        const handleOverScroll = (event) => {
            const scrollTop = window.scrollY;
            if (scrollTop > 0) return;

            if (event.type === "touchstart") {
                startY = event.touches[0].clientY;
            } else if (event.type === "touchmove") {
                moveY = event.touches[0].clientY;
                if (moveY > startY) {
                    window.dispatchEvent(new CustomEvent("closeSubToMain"));
                }
            } else if (event.type === "wheel") {
                if (event.deltaY < 0) {
                    window.dispatchEvent(new CustomEvent("closeSubToMain"));
                }
            }
        };

        // window.addEventListener("touchstart", handleOverScroll);
        // window.addEventListener("touchmove", handleOverScroll);
        // window.addEventListener("wheel", handleOverScroll);
        return () => {
            // console.log("Contact use effect return")
            // window.removeEventListener("touchstart", handleOverScroll);
            // window.removeEventListener("touchmove", handleOverScroll);
            // window.removeEventListener("wheel", handleOverScroll);
        }
    }, []);



    const handleButtonClick = (url) => {
        window.open(url, "_blank");
    };

    return (
        <div id="contact" className="contact-container">
            <div className="contact-gradient-1"></div>
            <div className="contact-gradient-2"></div>
            <Footer
                lang={lang}
                isContactPage={true} />
        </div>
    );
};

export default Contact;